import baseApi from "../../core/lib/base";
import { EventModel, EventResponseModel } from '../../types/event';

export const eventApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getEvents: builder.query<EventResponseModel,
            {
                pageNumber?: number;
                pageSize?: number;
                from?: string;
                to?: string;
                search?: string;
                categoryId?: string;
                role?: string;
                status?: string;
                location?: string;
                eventId?: string;
            }
        >({
            query: (queryParameters) => {
                const {
                    pageNumber,
                    pageSize,
                    from,
                    to,
                    search,
                    status,
                    role,
                    eventId,
                    location,
                    categoryId,
                } = queryParameters;
                return {
                    method: "GET",
                    url: "/event/available",
                    params: {
                        pageNumber,
                        pageSize,
                        from,
                        to,
                        role,
                        status,
                        location,
                        eventId,
                        search,
                        categoryId,
                        channel: 1
                    },
                };
            },
            onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
                try {
                     await queryFulfilled;
                } catch {
                  // swallow API errors; UI falls back to campaign config
                }
            },
        }),

        getPastEvents: builder.query<EventResponseModel,
            {
                pageNumber?: number;
                pageSize?: number;
                location?: string;
                categoryId?: string;
                search?: string;
            }
        >({
            query: (queryParameters) => {
                const {
                    pageNumber,
                    pageSize,
                    location,
                    categoryId,
                    search
                } = queryParameters;
                return {
                    method: "GET",
                    url: "/event/past-events",
                    params: {
                        pageNumber,
                        pageSize,
                        location,
                        categoryId,
                        search,
                        channel: 1
                    },
                };
            },
            onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
                try {
                     await queryFulfilled;
                } catch {
                  // swallow API errors; UI falls back to campaign config
                }
            },
        }),

        getSingleEvent: builder.query<EventModel,
            {
                slug: string;
            }
        >({
            query: (queryParameters) => {
                const { slug } = queryParameters;
                return {
                    method: "GET",
                    url: `/event/${slug}`,
                };
            },
            onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
                try {
                     await queryFulfilled;
                } catch {
                  // swallow API errors; UI falls back to campaign config
                }
            },
        }),

        getEventLocations: builder.query<string[], {}>({
            query: () => {
                return {
                    method: "GET",
                    url: "/event/locations",
                };
            },
            onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
                try {
                     await queryFulfilled;
                } catch {
                  // swallow API errors; UI falls back to campaign config
                }
            },
        }),
    })
});

export const { useGetEventsQuery, useGetPastEventsQuery, useGetSingleEventQuery, useGetEventLocationsQuery } = eventApi;
